import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["url", "favicon", "type", "preview"]
  static values = {
    faviconUrl: String
  }

  connect() {
    if (this.hasUrlTarget && this.urlTarget.value) {
      this.updatePreview()
    }
  }

  updatePreview() {
    const url = this.urlTarget.value
    if (!url) return

    // Update favicon
    if (this.hasFaviconTarget) {
      const domain = new URL(url).hostname
      this.faviconTarget.src = `https://www.google.com/s2/favicons?domain=${domain}&sz=32`
    }

    // Update link type
    if (this.hasTypeTarget) {
      if (url.includes("sharepoint.com") || url.includes("onedrive.live.com")) {
        this.typeTarget.innerHTML = `
          <div class="flex items-center text-xs text-gray-500">
            <i class="fab fa-microsoft mr-1"></i>
            Microsoft 365
          </div>
        `
      } else if (url.includes("docs.google.com")) {
        this.typeTarget.innerHTML = `
          <div class="flex items-center text-xs text-gray-500">
            <i class="fab fa-google mr-1"></i>
            Google Docs
          </div>
        `
      } else if (url.includes("office.com")) {
        this.typeTarget.innerHTML = `
          <div class="flex items-center text-xs text-gray-500">
            <i class="fas fa-file-word mr-1"></i>
            Office Online
          </div>
        `
      } else {
        this.typeTarget.innerHTML = ''
      }
    }

    // Show preview
    if (this.hasPreviewTarget) {
      this.previewTarget.classList.remove('hidden')
    }
  }

  // Called when URL input changes
  urlChanged() {
    this.updatePreview()
  }
} 